import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Tabs } from '@tencent/spaui';
import _ from 'lodash';
import * as pathToRegexp from 'path-to-regexp';
import StaticTip from '@/common-components/static-tip';
import globalStore from '@/stores/index';
import dialog from '@/utils/dialog';
import { getPageConfig } from '@/pages/agency/utils/util';
import './assets/less/index.scoped.less';

const supportSwitchList = ['/agency/advertiser-list/:type', '/agency/advertising/:type', '/agency/finance-info/:type', '/agency/finance-record/:type', '/agency/finance-credit/:type'];

export interface TabNavProps {
  /**
   * 页面地址
   */
  href?: string;
  /**
   * 页面地址
   */
  endOfHeadContent?: any;
}

export const TabNav: React.FC<TabNavProps> = (props) => {
  const { href = '', endOfHeadContent } = props;
  const account: any = globalStore.account || {};
  const history: any = globalStore.history || {};
  const pathname = href || history?.location?.pathname;
  const [value, setValue] = useState(pathname);
  const { siteMap = {} } = account;
  const currentTabNav: any[] = siteMap.pathTabNavMap?.[pathname] || [];

  useEffect(() => {
    if (currentTabNav) {
      currentTabNav.forEach((item, index) => {
        if (item.match && item.match(pathname)) {
          setValue(item.href);
        }
      });
    }
  }, [pathname]);

  const onChange = useCallback((e, value) => {
    const currentHref = pathname;
    let currentType = '';
    let targetHref = '';
    let haveTargeHref = false;

    const haveJumpPermissions = !getPageConfig(value).pagePurview.notYetOpen?.(account);

    supportSwitchList.forEach((v) => {
      // 生成正则
      const match = pathToRegexp.match(v, { decode: decodeURIComponent });
      // 匹配当前页href，提取type
      const currentResult: any = match(currentHref);
      if (currentType === '' && Boolean(currentResult)) {
        currentType = currentResult.params.type;
      }
      // 匹配目标页href
      const targetResult = match(value);
      if (targetHref === '' && Boolean(targetResult)) {
        targetHref = v;
      }
    });

    // 如果当前页和目标页同时满足自动跳转，则填充目标页href
    if (currentType !== '' && targetHref !== '') {
      const compile = pathToRegexp.compile(targetHref, { encode: encodeURIComponent });
      targetHref = compile({ type: currentType });
      haveTargeHref = _.filter(siteMap.routes, (v) => v.href === targetHref).length > 0;
    }

    // 如果目标链接前缀支持自动跳转到对应广告类别 且 对应广告类别的链接是有权限访问的则跳转，否则跳转默认链接
    if (haveJumpPermissions) {
      setValue(value);
      if (targetHref !== '' && haveTargeHref) {
        history?.push(targetHref);
      } else {
        history?.push(value);
      }
    } else {
      dialog.alert('您好，此版块详情内容尚未开放，申请流程待进一步通知或咨询对应渠道经理');
    }
  }, []);

  if (!currentTabNav.length) {
    return null;
  }

  return (
    <Tabs className="tab-nav" value={value} unmountInactivePanel={true} needSlider={false} onChange={onChange} endOfHeadContent={<div className="tab-nav-right">{endOfHeadContent}</div>}>
      {currentTabNav.map((item, index) => {
        const href = item.href;
        return (
          <TabPanel
            key={href}
            tab={
              item.tip ? (
                <>
                  {item.label}
                  <StaticTip style={{ marginLeft: 10 }}>{item.tip}</StaticTip>
                </>
              ) : (
                item.label
              )
            }
            name={href}
            data-report-global={`second-nav.${item.key || item.id || item.href}`}
          ></TabPanel>
        );
      })}
    </Tabs>
  );
};

export default TabNav;

